"use client";

import { useEffect, useState } from "react";
import { useRouter, usePathname } from "next/navigation";
import { Shield, Settings } from "lucide-react";
import { useAdmin } from "@/context/AdminContext";
import styles from "./TopBar.module.css";

type User = { email: string; role: string; libelle_role: string } | null;

const ADMIN_ROLES = ["superadmin", "admin"];
const MEMBER_ROLES = ["editor", "member_free", "member_paid"];

export default function TopBar() {
  const [user, setUser] = useState<User>(null);
  const { isAdmin, setIsAdmin, isMemberMode, setIsMemberMode } = useAdmin();
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    fetch("/api/auth/me", { credentials: "include" })
      .then(res => res.ok ? res.json() : null)
      .then(data => setUser(data))
      .catch(() => setUser(null));
  }, [pathname]);

  async function handleLogout() {
    await fetch("/api/auth/logout", { method: "POST", credentials: "include" });
    setUser(null);
    setIsAdmin(false);
    setIsMemberMode(false);
    router.push("/");
  }

  const canAdmin = user && ADMIN_ROLES.includes(user.role);
  const isMember = user && MEMBER_ROLES.includes(user.role);

  return (
    <div className={styles.bar}>
      <a href="/a-propos" className={styles.link}>À propos</a>

      {user ? (
        <div className={styles.userinfo}>
          {canAdmin && (
            <button
              className={`${styles.iconBtn} ${isAdmin ? styles.iconOn : ''}`}
              onClick={() => {
                const next = !isAdmin;
                setIsAdmin(next);
                router.push(next ? "/admin/membres" : "/");
              }}
              title={isAdmin ? "Quitter l'administration" : "Mode administration"}
            >
              <Shield size={14} fill={isAdmin ? "currentColor" : "none"} />
            </button>
          )}
          {isMember && (
            <button
              className={`${styles.iconBtn} ${isMemberMode ? styles.iconOn : ''}`}
              onClick={() => {
                const next = !isMemberMode;
                setIsMemberMode(next);
                router.push(next ? "/profil" : "/");
              }}
              title={isMemberMode ? "Fermer le profil" : "Mon profil"}
            >
              <Settings size={14} />
            </button>
          )}
          <span className={styles.usermeta}>{user.email} · {user.libelle_role}</span>
          <button className={styles.link} onClick={handleLogout}>Déconnexion</button>
        </div>
      ) : (
        <a href="/connexion" className={styles.link}>Connexion</a>
      )}
    </div>
  );
}
